/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { makeStyles } from '@mui/styles';

export const useSetupPageStyles = makeStyles(theme => ({
  root: {
    marginTop: '15px',
    flex: 1,
  },
  formWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '380px',
    width: '100%',
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: '20px',
  },
  errorBlock: {
    marginTop: '10px',
    marginBottom: '5px',
  },
  errorLine: {
    color: theme.palette.error.main,
    margin: '2px 0px',
    marginLeft: '1.8rem',
    fontWeight: '500',
  },
  modalError: {
    textAlign: 'left',
    whiteSpace: 'pre-wrap',
  },
  formActions: {
    display: 'flex',
    gap: '10px',
    marginTop: '20px',
  },
  steps: {
    display: 'flex',
    justifyContent: 'center',
    margin: '25px 0 25px',
  },
  stepsLabel: {
    textAlign: 'center',
  },
  testEmailInfo: {
    marginTop: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
}));
